import SponsoredAdvertsRouter from './SponsoredAdverts.router';

export default SponsoredAdvertsRouter;